import axios from "@lib/axios";

export async function getBrands(tag) {
  const res = await axios.get("brands", { params: { tag } });
  return res.data.data;
}

export async function getBrand(slug) {
  const res = await axios.get(`brands/${slug}`);
  return res.data.data;
}
